// import { IS_LOCALHOST } from '@/config/constants'

export const IS_LOCALHOST = (location.hostname == 'localhost' || location.hostname == 'webapp' || location.hostname.match(/ngrok.io/)) ? true : false


export const XPAND_BASEURL = (() => {
  if(location.host == 'www.gavlegardarna.se' )
    return 'https://xpand.gavlegardarna.se';

  return 'https://xpandtest.gavlegardarna.se';
})();

export const API_BASEURL = (() => {
  if(location.host == 'www.gavlegardarna.se' || (IS_LOCALHOST && 1 == 2))
    return 'https://abg-mypages-api.azurewebsites.net/api';

  return 'https://tstv20-abg-mypages-api.azurewebsites.net/api';
})();

export const API_BASEURL_V2 = (() => {
  if(location.host == 'www.gavlegardarna.se' || (IS_LOCALHOST && 1 == 2))
    return 'https://mypages-api.gavlegardarna.se/api';

  return 'https://mypages-api-test.gavlegardarna.se/api';
})();

export const neighbourhoods = [
  "Andersberg",
  "Bergby",
  "Bomhus",
  "Brynäs",
  "Forsbacka",
  "Fridhem",
  "Gävle Strand",
  "Hagaström",
  "Hedesunda",
  "Hemsta",
  "Nordost",
  "Norr",
  "Norrsundet",
  "Stigslund",
  "Sätra",
  "Söder",
  "Södertull",
  "Södra Hemlingby",
  "Sörby",
  "Valbo",
  "Villastaden",
  "Öster"
];

export const neighbourhoodsStudent = [
  "Södertull",
  "Sätra",
  "Villastaden",
  "Söder"
];

export const parkingOptions = [
"Båtplats",
"Carport",
"Kallgarage",
"Motorcykelgarage",
"Parkering",
"P-plats för husvagn"
];

export const apartmentTypes = [
"Lägenheter",
"Tryggbo plus",
"Startbo",
"Tryggbo"
];
// export const rentalObjectTypes = [
//   {
//     rentalObjectType: "BILPL1",
//     caption : "Garage och carport",
//     lowerAge : 18,
//     upperAge : null,
//     toBePublished : true,
//     waitingListType: "Torget. bil"
//   },
//   {
//     rentalObjectType: "BILPL2",
//     caption : "P-Platser",
//     lowerAge : 18,
//     upperAge : null,
//     toBePublished : true,
//     waitingListType: "Torget. bil"
//   },
//   {
//     rentalObjectType: "BILPL3",
//     caption : "Varmgarage, nyproduktion",
//     lowerAge : null,
//     upperAge : null,
//     toBePublished : false,
//     waitingListType: ""
//   },
//   {
//     rentalObjectType: "LGH1",
//     caption : "Bostadslägenhet",
//     lowerAge : 18,
//     upperAge : null,
//     toBePublished : true,
//     waitingListType: "Torget, lgh"
//   },
//   {
//     rentalObjectType: "LGH2",
//     caption : "Tryggbo",
//     lowerAge : 55,
//     upperAge : null,
//     toBePublished : true,
//     waitingListType: "Torget, lgh"
//   },
//   {
//     rentalObjectType: "LGH20",
//     caption : "Studentbostad",
//     lowerAge : 18,
//     upperAge : null,
//     toBePublished : true,
//     waitingListType: "Torget, student"
//   },
//   {
//     rentalObjectType: "LGH3",
//     caption : "Ungdomskampanj 10",
//     lowerAge : 18,
//     upperAge : 24,
//     toBePublished : false,
//     waitingListType: ""
//   },
//   {
//     rentalObjectType: "LGH4",
//     caption : "Tryggbo Plus",
//     lowerAge : 65,
//     upperAge : null,
//     toBePublished : true,
//     waitingListType: "Torget, lgh"
//   },
//   {
//     rentalObjectType: "LGH40",
//     caption : "Småhus",
//     lowerAge : null,
//     upperAge : null,
//     toBePublished : false,
//     waitingListType: ""
//   },
//   {
//     rentalObjectType: "LGH41",
//     caption : "Samfälligheter",
//     lowerAge : null,
//     upperAge : null,
//     toBePublished : false,
//     waitingListType: ""
//   },
//   {
//     rentalObjectType: "LGH5",
//     caption : "Startbo",
//     lowerAge : 18,
//     upperAge : 25,
//     toBePublished : true,
//     waitingListType: "Torget, lgh"
//   },
//   {
//     rentalObjectType: "LGH9",
//     caption : "Nyproduktion",
//     lowerAge : 18,
//     upperAge : null,
//     toBePublished : true,
//     waitingListType: ""
//   },
//   {
//     rentalObjectType: "LGH96",
//     caption : "Paviljong",
//     lowerAge : null,
//     upperAge : null,
//     toBePublished : false,
//     waitingListType: ""
//   },
//   {
//     rentalObjectType: "LOK1",
//     caption : "Lokal",
//     lowerAge : null,
//     upperAge : null,
//     toBePublished : false,
//     waitingListType: ""
//   },
//   {
//     rentalObjectType: "LOK2",
//     caption : "Butik",
//     lowerAge : null,
//     upperAge : null,
//     toBePublished : false,
//     waitingListType: ""
//   },
//   {
//     rentalObjectType: "LOK3",
//     caption : "Förråd",
//     lowerAge : 18,
//     upperAge : null,
//     toBePublished : true,
//     waitingListType: "Torget, förråd"
//   },
//   {
//     rentalObjectType: "LOK4",
//     caption : "Gruppboende",
//     lowerAge : null,
//     upperAge : null,
//     toBePublished : false,
//     waitingListType: ""
//   },
//   {
//     rentalObjectType: "ÖVR1",
//     caption : "Övrigt",
//     lowerAge : null,
//     upperAge : null,
//     toBePublished : false,
//     waitingListType: ""
//   },
// ];
// export const vehicleSpaceTypes = [
//   {
//     rentalObjectType : "BÅTPL",
//     caption : "Båtplats",
//     vat : "No"
//   },
//   {
//     rentalObjectType : "C-PORT",
//     caption : "Carport",
//     vat : "Principle of vicinity"
//   },
//   {
//     rentalObjectType : "K-GAR",
//     caption : "Kallgarage",
//     vat : "Principle of vicinity"
//   },
//   {
//     rentalObjectType : "MC-GAR",
//     caption : "Motorcykelgarage",
//     vat : "Yes"
//   },
//   {
//     rentalObjectType : "PPHUSV",
//     caption : "P-plats för husvagn",
//     vat : "Yes"
//   },
//   {
//     rentalObjectType : "PPL+MV",
//     caption : "P-plats med motorvärmare",
//     vat : "Principle of vicinity"
//   },
//   {
//     rentalObjectTypes : "PPLATS",
//     caption : "Parkeringsplats",
//     vat : "Principle of vicinity"
//   },
//   {
//     rentalObjectType : "V-GAR",
//     caption : "Varmgarage",
//     vat : "Principle of vicinity"
//   },
// ];
export const dwellingTypes =[
  {
    dwellingType : null,
    caption : "...",
    numberOfRooms : 0
  },
  {
    dwellingType : "1 ROK",
    caption : "1 rum och kök",
    numberOfRooms : 1
  },
  {
    dwellingType : "1 ROKM",
    caption : "1 rum och kök, möblerat",
    numberOfRooms : 1
  },
  {
    dwellingType : "1 ROKS",
    caption : "1 rum och kokskåp",
    numberOfRooms : 1
  },
  {
    dwellingType : "1 ROKV",
    caption : "1 rum och kokvrå",
    numberOfRooms : 1
  },
  {
    dwellingType : "1+2H+K",
    caption : "1 rum + 2 halva rum + kök",
    numberOfRooms : 1
  },
  {
    dwellingType : "1+H+K",
    caption : "1 rum + 1 halvt rum + kök",
    numberOfRooms : 1
  },
  {
    dwellingType : "1+H+KV",
    caption : "1 rum + 1 halvt rum + kök",
    numberOfRooms : 1
  },
  {
    dwellingType : "1R+A+K",
    caption : "1 rum + alkov + kök",
    numberOfRooms : 1
  },
  {
    dwellingType : "1ROKMM",
    caption : "1 rum och kök, möbl. + madrass",
    numberOfRooms : 1
  },
  {
    dwellingType : "1ROKVM",
    caption : "1 rum och kokvrå, möblerad",
    numberOfRooms : 1
  },
  {
    dwellingType : "1RUTAN",
    caption : "1 rum utan kök",
    numberOfRooms : 1
  },
  {
    dwellingType : "2 ROK",
    caption : "2 rum och kök",
    numberOfRooms : 2
  },
  {
    dwellingType : "2ROKV",
    caption : "2 rum och kokvrå",
    numberOfRooms : 2
  },
  {
    dwellingType : "2+H+K",
    caption : "2 rum + 1 halvt rum + kök",
    numberOfRooms : 2
  },
  {
    dwellingType : "2R+KSK",
    caption : "2 rum och kokskåp",
    numberOfRooms : 2
  },
  {
    dwellingType : "3 ROK",
    caption : "3 rum och kök",
    numberOfRooms : 3
  },
  {
    dwellingType : "3+H+K",
    caption : "3 rum +1 halvt rum + kök",
    numberOfRooms : 3
  },
  {
    dwellingType : "4 ROK",
    caption : "4 rum och kök",
    numberOfRooms : 4
  },
  {
    dwellingType : "5 ROK",
    caption : "5 rum och kök",
    numberOfRooms : 5
  },
  {
    dwellingType : "6 ROK",
    caption : "6 rum och kök",
    numberOfRooms : 6
  },
  {
    dwellingType : "7 ROK",
    caption : "7 rum och kök",
    numberOfRooms : 7
  },
  {
    dwellingType : "PAVIL",
    caption : "Paviljongboende",
    numberOfRooms : null
  },
  {
    dwellingType : "R+KSK",
    caption : "1 rum med kokskåp",
    numberOfRooms : 1
  },
  {
    dwellingType : "SMÅHUS",
    caption : "Småhus, Samfällighet",
    numberOfRooms : 0
  },
  {
    dwellingType : "STUDR",
    caption : "Studentrum",
    numberOfRooms : 1
  },
];

export const sortOptions = [
  { label: "Senast publicerad först", value:"publishedFromTsDesc", table: "publishedFromTs", sortorder: "desc" },
  { label: "Tidigast tillträde först", value:"accessDate", table: "vacantFrom", sortorder: "asc" },
  { label: "Lägst hyra först", value:"monthRentAsc", table: "monthRent", sortorder: "asc" },
  { label: "Störst först (m2)", value:"quantityBraDesc", table: "quantityBRA", sortorder: "desc" },
  { label: "Minst först (m2)", value:"quantityBraAsc", table: "quantityBRA", sortorder: "asc" }
];


export const apartmentArea = [
  { value: 15, label: '15' },
  { value: 20, label: '20' },
  { value: 25, label: '25' },
  { value: 30, label: '30' },
  { value: 35, label: '35' },
  { value: 40, label: '40' },
  { value: 45, label: '45' },
  { value: 50, label: '50' },
  { value: 55, label: '55' },
  { value: 60, label: '60' },
  { value: 65, label: '65' },
  { value: 70, label: '70' },
  { value: 75, label: '75' },
  { value: 100, label: '100' },
  { value: 120, label: '120' },
  { value: 150, label: '150' },
  { value: 170, label: '170' },
  { value: 200, label: '200' },
  { value: 250, label: '250' }
];


export const rentAmountsOther = [
  { value: 200, label: '200' },
  { value: 300, label: '300' },
  { value: 500, label: '500' },
  { value: 1000, label: '1000' },
  { value: 1500, label: '1500' },
  { value: 2000, label: '2000' },
  { value: 2500, label: '2500' },
  { value: 3000, label: '3000' },
  { value: 4000, label: '4000' },
  { value: 5000, label: '5000' },
  { value: 6000, label: '6000' },
  { value: 7000, label: '7000' },
  { value: 8000, label: '8000' }
];

export const otherArea = [
  { value: 3, label: '3' },
  { value: 5, label: '5' },
  { value: 10, label: '10' },
  { value: 15, label: '15' },
  { value: 20, label: '20' },
  { value: 25, label: '25' },
  { value: 30, label: '30' }
];

export const roomAmount = [
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5' },
  { value: 6, label: '6' },
  { value: 7, label: '7' },
  { value: 8, label: '8' }
];

export const rentAmounts = [
  { value: 3000, label: '3000' },
  { value: 4000, label: '4000' },
  { value: 5000, label: '5000' },
  { value: 6000, label: '6000' },
  { value: 7000, label: '7000' },
  { value: 8000, label: '8000' },
  { value: 9000, label: '9000' },
  { value: 10000, label: '10000' },
  { value: 11000, label: '11000' },
  { value: 12000, label: '12000' },
  { value: 15000, label: '15000' },
  { value: 20000, label: '20000' },
  { value: 25000, label: '25000' }
];


export const messageOption =[
  "E-post",
  "Brev"
];

export const areas=[

  //Level 0/1
  {key: 'appartment', value: "Lägenheten"},
  {key: 'PP', value: "Parkering"},
  {key: 'FÖ', value: "Förråd"},
  {key: 'common', value: "Gemensamma utrymmen"},
  {key: 'GÅ', value: "Utomhus/gården"},
  {key: 'ÖVRIGT', value: "Övrigt"},

  //Level 1 - Lägenhet
  {key: 'BA', value: "Badrummet", parent: "appartment"},
  {key: 'HA', value: "Hallen", parent: 'appartment'},
  {key: 'KÖ', value: "Köket", parent: 'appartment'},
  {key: 'SO', value: "Sovrummet", parent: 'appartment'},
  {key: 'VA', value: "Vardagsrummet", parent: 'appartment'},
  //Level 1 - Gemensamma
  {key: 'TH', value: "Trapphuset", parent: "common"},
  {key: 'TV', value: "Tvättstuga", parent: 'common'},
  {key: 'MI', value: "Återvinningsrum", parent: 'common'},
  {key: 'KÄ', value: "Källare", parent: 'common'},
  {key: '', value: "Förråd", parent: 'common'},
  {key: '', value: "Annan plats", parent: 'common'},
  //Level 2 - Utomhus
  {key: 'YB', value: "Belysning", parent: 'GÅ'},
  {key: 'LE', value: "Lekplats", parent: 'GÅ'}, //Level 1
  {key: '', value: "Papperskorgar", parent: 'GÅ'},
  {key: 'PL', value: "Planteringar", parent: 'GÅ'},
  {key: 'UM', value: "Utemöbler", parent: 'GÅ'},
  {key: '', value: "Annat fel", parent: 'GÅ'},
  //Level 2 - Övrigt
  {key: '', value: "Fråga om besiktning", parent: 'ÖVRIGT'},
  {key: '', value: "Fråga om parkering", parent: 'ÖVRIGT'},
  {key: '', value: "Fråga om underhåll", parent: 'ÖVRIGT'},
  {key: '', value: "Fråga om faktura/avi", parent: 'ÖVRIGT'},
  {key: '', value: "Störningar", parent: 'ÖVRIGT'},
  {key: '', value: "Övriga frågor", parent: 'ÖVRIGT'},

  //Badrum
  {key: 'EL', value: "El", parent: "BA"},
  {key: 'AV', value: "Vatten/avlopp", parent: "BA"},
  {key: '', value: "Värme", parent: "BA"},
  {key: '', value: "Skadedjur", parent: "BA"},
  {key: '', value: "Tapeter och mattor", parent: "BA"},
  {key: '', value: "Ventilation", parent: "BA"},
  {key: '', value: "Annat fel", parent: "BA"},
  //Kök
  {key: 'EL', value: "El", parent: "KÖ"},
  //mapps against Diskbänk since there is no Avlopp
  {key: 'DI', value: "Vatten/avlopp", parent: "KÖ"},
  {key: 'VL', value: "Värme", parent: "KÖ"},
  {key: '', value: "Skadedjur", parent: "KÖ"},
  {key: '', value: "Tapeter och mattor", parent: "KÖ"},
  {key: '', value: "Ventilation", parent: "KÖ"},
  {key: '', value: "Spis", parent: "KÖ"},
  {key: '', value: "Kyl", parent: "KÖ"},
  {key: '', value: "Frys", parent: "KÖ"},
  {key: '', value: "Annat fel", parent: "KÖ"},
  {key: '', value: "DM", parent: "KÖ"},
  //Sovrum
  {key: 'EL', value: "El", parent: "SO"},
  {key: '', value: "Skadedjur", parent: "SO"},
  {key: '', value: "Tapeter och mattor", parent: "SO"},
  {key: '', value: "Annat fel", parent: "SO"},
  //Vardagsrum
  {key: 'EL', value: "El", parent: "VA"},
  {key: '', value: "Skadedjur", parent: "VA"},
  {key: '', value: "Tapeter och mattor", parent: "VA"},
  {key: '', value: "Annat fel", parent: "VA"},
  //Hall
  {key: '', value: "Brandvarnare", parent: "HA"},
  {key: '', value: "Bredbandsuttag", parent: "HA"},
  {key: '', value: "Porttelefon", parent: "HA"},
  {key: '', value: "Skadedjur", parent: "HA"},
  {key: '', value: "Tapeter och mattor", parent: "HA"},
  {key: '', value: "Lägenhetsdörr", parent: "HA"},
  {key: '', value: "Annat fel", parent: "HA"},
];

export const accesses =[
  "Är hemma",
  "Ej huvudnycket",
  "Extra lås",
  "Huvudnyckel",
  "Ring före",
  "Utomhus"
];

export const pets =[
  "Inget",
  "Hund",
  "Katt",
  "Annat"
];
